import Loader from './Loader'

const ConditionalBalance = ({ disabled, balanceLoaded, children }) =>
  disabled ? <span>N/A</span> : balanceLoaded ? children : <Loader />
export default ConditionalBalance
